// Nettoyage HTML anti-XSS côté affichage (défense en profondeur, en plus du serveur).
// La liste blanche reflète celle du backend (sanitize.py) : balises/attributs produits par
// l'éditeur Tiptap (titres, mise en forme, tableaux, figures, encadrés, coupure d'aperçu,
// liens internes/glossaire, formules KaTeX) et vidéos YouTube uniquement.
import DOMPurify from "dompurify";

// Attributs data-* conservés (Tiptap, KaTeX, figures, glossaire, liens internes, aperçu)
const DATA_ATTRS = [
  "data-type", "data-latex",
  "data-callout", "data-figure", "data-align", "data-width",
  "data-caption", "data-source", "data-preview-break",
  "data-glossary", "data-internal", "data-no-gloss", "data-youtube-video",
  "data-gloss-auto", "data-gloss-def", "data-gloss-title",
];

const YT_RE = /^https?:\/\/(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.be)\//i;

// Propriétés CSS interdites dans un attribut style (anti-overlay : faux formulaire plein écran).
const BANNED_CSS_PROPS = ["position", "z-index", "top", "left", "right", "bottom", "inset", "transform"];

let hookAdded = false;
function ensureHook() {
  if (hookAdded) return;
  // Supprime toute iframe dont la source n'est pas une vidéo YouTube.
  DOMPurify.addHook("uponSanitizeElement", (node, data) => {
    if (data.tagName === "iframe") {
      const src = (node.getAttribute && node.getAttribute("src")) || "";
      if (!YT_RE.test(src) && node.parentNode) {
        node.parentNode.removeChild(node);
      }
    }
  });
  // Nettoie les attributs style : retire position/z-index/top/left/right/bottom/inset/transform
  // et toute déclaration contenant url( (empêche un faux calque plein écran).
  DOMPurify.addHook("afterSanitizeAttributes", (node) => {
    if (!node.style || !node.getAttribute || !node.getAttribute("style")) return;
    BANNED_CSS_PROPS.forEach((p) => node.style.removeProperty(p));
    for (let i = node.style.length - 1; i >= 0; i--) {
      const prop = node.style[i];
      if (/url\(/i.test(node.style.getPropertyValue(prop))) node.style.removeProperty(prop);
    }
    if (!node.getAttribute("style")) node.removeAttribute("style");
  });
  hookAdded = true;
}

/** Renvoie une version nettoyée du HTML (chaîne). Entrée vide/non-string → "". */
export function safeHtml(html) {
  if (!html || typeof html !== "string") return "";
  ensureHook();
  return DOMPurify.sanitize(html, {
    ADD_TAGS: ["iframe"],
    ADD_ATTR: ["target", "allow", "allowfullscreen", "frameborder", "loading", ...DATA_ATTRS],
    ALLOW_DATA_ATTR: true,
  });
}
